/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { NetCDFFileTypeEnum } from "./NetCDFFileTypeEnum";
import {
  NetCDFFileTypeEnumFromJSON,
  NetCDFFileTypeEnumFromJSONTyped,
  NetCDFFileTypeEnumToJSON,
  NetCDFFileTypeEnumToJSONTyped,
} from "./NetCDFFileTypeEnum";
import type { RasterRainUnitsEnum } from "./RasterRainUnitsEnum";
import {
  RasterRainUnitsEnumFromJSON,
  RasterRainUnitsEnumFromJSONTyped,
  RasterRainUnitsEnumToJSON,
  RasterRainUnitsEnumToJSONTyped,
} from "./RasterRainUnitsEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface FileRasterSourcesSinks
 */
export interface FileRasterSourcesSinks {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number | null;
  /**
   * Duration of event in seconds
   */
  duration?: number | null;
  /**
   * in simulation in seconds
   */
  timestamps?: Array<number> | null;
  /**
   * interval in seconds
   */
  interval?: number | null;
  /**
   *
   */
  valuesReference?: string | null;
  /**
   *
   */
  fillValue?: string;
  /**
   *
   */
  units?: RasterRainUnitsEnum | null;
  /**
   *
   */
  geotransform?: Array<number>;
  /**
   *
   */
  epsgCode?: number;
  /**
   *
   */
  file?: FileReadOnly;
  /**
   *
   */
  readonly type?: NetCDFFileTypeEnum;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the FileRasterSourcesSinks interface.
 */
export function instanceOfFileRasterSourcesSinks(value: object): value is FileRasterSourcesSinks {
  return true;
}

export function FileRasterSourcesSinksFromJSON(json: any): FileRasterSourcesSinks {
  return FileRasterSourcesSinksFromJSONTyped(json, false);
}

export function FileRasterSourcesSinksFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FileRasterSourcesSinks {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    timestamps:
      json["timestamps"] === undefined
        ? undefined
        : json["timestamps"] === null
        ? null
        : json["timestamps"],
    interval:
      json["interval"] === undefined
        ? undefined
        : json["interval"] === null
        ? null
        : json["interval"],
    valuesReference:
      json["values_reference"] === undefined
        ? undefined
        : json["values_reference"] === null
        ? null
        : json["values_reference"],
    fillValue: json["fill_value"] == null ? undefined : json["fill_value"],
    units:
      json["units"] === undefined
        ? undefined
        : json["units"] === null
        ? null
        : RasterRainUnitsEnumFromJSON(json["units"]),
    geotransform: json["geotransform"] == null ? undefined : json["geotransform"],
    epsgCode: json["epsg_code"] == null ? undefined : json["epsg_code"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    type: json["type"] == null ? undefined : NetCDFFileTypeEnumFromJSON(json["type"]),
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function FileRasterSourcesSinksToJSON(json: any): FileRasterSourcesSinks {
  return FileRasterSourcesSinksToJSONTyped(json, false);
}

export function FileRasterSourcesSinksToJSONTyped(
  value?: Omit<FileRasterSourcesSinks, "url" | "simulation" | "type" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    multiplier: value["multiplier"],
    offset: value["offset"],
    duration: value["duration"],
    timestamps: value["timestamps"],
    interval: value["interval"],
    values_reference: value["valuesReference"],
    fill_value: value["fillValue"],
    units: RasterRainUnitsEnumToJSON(value["units"]),
    geotransform: value["geotransform"],
    epsg_code: value["epsgCode"],
    file: FileReadOnlyToJSON(value["file"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
